"use strict";

var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel');

/**
 * Image model has no endpoint as of yet. In the future this may be available via image service.
 * Leave this named `ImageModel` since the html5 spec has a new `Image` global
 * @type {Object|Function}
 */
var ImageModel = SoaModel.extend();

_.extend(ImageModel, {
    UPLOAD_TYPE_DEALER: 'USER',
    UPLOAD_TYPE_1STDIBS: '_1STDIBS'
});

_.extend(ImageModel.prototype, {

    /**
     * Determines if the image in question is the first image.
     * @returns {boolean}
     */
    isImgOne : function () {
        return this.get('position').toString() === '1';
    },

    /**
     * Returns who uploaded the image
     * @returns string
     */
    getPhotoProvider: function() {
        var provider = this.get('uploadType');
        if (provider === this.UPLOAD_TYPE_DEALER) {
            return 'dealer';
        } else if (provider === this.UPLOAD_TYPE_1STDIBS) {
            return '1stdibs';
        }
        return null;
    }
});

module.exports = ImageModel;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Image.js
// module id = 2638
// module chunks = 62